
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class NavItemLink extends Vue {
  @Prop({ default: '' }) icon!: string;

  @Prop({ default: '' }) to!: string;
}
